import IconHooks from '../assets/icons/icon-hooks.png';
import IconTesting from '../assets/icons/icon-react-testing.png';
import IconStyledComponets from '../assets/icons/icon-styledComponets.png';

export const skills = [
  {
    title: 'Languages',
    icons: [
      {
        title: 'HTML',
        icon: true,
        img: false,
        url: 'vscode-icons:file-type-html',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Javascript',
        icon: true,
        img: false,
        url: 'logos:javascript',
        width: '35',
        color: '',
        height: '35',
        imgUrl: '',
      },
      {
        title: 'CSS',
        icon: true,
        img: false,
        url: 'vscode-icons:file-type-css',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Git',
        icon: true,
        img: false,
        url: 'bi:git',
        width: '40',
        color: '#f1502f',
        height: '40',
        imgUrl: '',
      },
    ],
  },
  {
    title: 'Dev Tools',
    icons: [
      {
        title: 'React',
        icon: true,
        img: false,
        url: 'vscode-icons:file-type-reactjs',
        color: '',
        width: '50',
        height: '50',
        imgUrl: '',
      },
      {
        title: 'Redux',
        icon: true,
        img: false,
        url: 'logos:redux',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Redux Saga',
        icon: true,
        img: false,
        url: 'logos:redux-saga',
        color: '',
        width: '50',
        height: '50',
        imgUrl: '',
      },
      {
        title: 'React Hooks',
        icon: false,
        img: true,
        url: '',
        width: '50',
        color: '',
        height: '50',
        imgUrl: IconHooks,
      },
      {
        title: 'React Testing Library',
        icon: false,
        img: true,
        url: '',
        color: '',
        width: '50',
        height: '50',
        imgUrl: IconTesting,
      },
      {
        title: 'Postman',
        icon: true,
        img: false,
        url: 'logos:postman-icon',
        color: '#f1502f',
        width: '40',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Styled Componets',
        icon: false,
        img: true,
        url: '',
        color: '',
        width: '50',
        height: '50',
        imgUrl: IconStyledComponets,
      },
      {
        title: 'Ant Design',
        icon: true,
        img: false,
        url: 'logos:ant-design',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Github',
        icon: true,
        img: false,
        url: 'icon-park:github',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Bitbucket',
        icon: true,
        img: false,
        url: 'logos:bitbucket',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Bootstrap',
        icon: true,
        img: false,
        url: 'logos:bootstrap',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Terminal',
        icon: true,
        img: false,
        url: 'ion:terminal',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
    ],
  },
  {
    title: 'Design Tools',
    icons: [
      {
        title: 'Font Awesome',
        icon: true,
        img: false,
        url: 'logos:font-awesome',
        width: '35',
        color: '',
        height: '35',
        imgUrl: '',
      },
      {
        title: 'Iconify.design',
        icon: true,
        img: false,
        url: 'simple-icons:iconify',
        width: '40',
        color: '#1769aa',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Tablet & S Pen',
        icon: true,
        img: false,
        url: 'iconoir:pen-tablet',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
      {
        title: 'Figma',
        icon: true,
        img: false,
        url: 'logos:figma',
        width: '40',
        color: '',
        height: '40',
        imgUrl: '',
      },
    ],
  },
];
